import { Box, Button, Grid } from "@mui/material";
import SetExplorer from "../../components/organisms/setExplorer/SetExplorer";
import AddIcon from '@mui/icons-material/Add';

import { enableWorkflow } from "../../store/dataProvisioningWorkflow/actions";
import DataProvisioningWorkflow from "../../components/organisms/dataProvisioningWorkflow/dataProvisioningWorkflow";
import { useDispatch } from "react-redux";
import { getRoleClaimsSelector } from "../../store/auth/selectors";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
const DataSetList = () => {
    const dispatch = useDispatch()
    const roles = useSelector(getRoleClaimsSelector);  // roles  - IDP.Admin or IDP.User
    const triggerEnableWorkflow = () => {
        dispatch(enableWorkflow())
    }

    const [isAdmin, setIsAdmin] = useState(true);
    useEffect(() => {
        if (roles && roles.length > 0) {
            setIsAdmin(roles.includes("IDP.Admin") ? true : false);
        }
    }, [roles]);

    return (
        <>
            <Box sx={{ paddingBottom: "10px", }}>
                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                    <Grid item xs={12}>
                        <h1 style={{ textAlign: "left" }}>Search the Unity Data Lake </h1>
                    </Grid>
                </Grid>
            </Box>
            <div style={{ marginBottom: '600px' }}>
                <SetExplorer  isAdmin={isAdmin}/>
            </div>
        </>
    )
}

export default DataSetList;